import { useState } from "react";
import { api } from "../api";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../assets/logo.png";
import { buildErrorHtml, isBlank, isEmail } from "../utils/validation";

export default function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  async function handleLogin() {
    const errors = [];

    if (!isEmail(email)) {
      errors.push("Informe um email válido.");
    }

    if (isBlank(password)) {
      errors.push("Informe a senha.");
    }

    if (errors.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Campos inválidos",
        html: buildErrorHtml(errors),
      });
      return;
    }

    try {
      const response = await api.post("/auth/login", {
        email,
        password,
      });

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      if (response.data.user.role === "COORDINATION") {
        navigate("/coordinator");
      } else {
        navigate("/dashboard");
      }

    } catch {
      Swal.fire("Erro", "Login inválido.", "error");
    }
  }

  return (
    <div className="login-page">

      <div className="login-container">

        <img
          src={logo}
          alt="SIMF"
          style={{ width: "180px", marginBottom: "20px" }}
        />

        <h4 className="mb-4">
          Sistema Inteligente para Monitoramento de Frequência
        </h4>

        <input
          placeholder="Email"
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Senha"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button onClick={handleLogin}>
          Entrar
        </button>

      </div>

    </div>
  );
}
